import React, { MouseEvent } from 'react';

import { Box, IconButton, Tooltip, CircularProgress } from '@mui/material';

import { IHomeBarButton } from './intefaces';

import { useStyles } from './styles';
import { COLORS } from '../../../../constants/colors';

const HomeBarButton = ({
  icon,
  handleClick,
  label,
  showPulseAnimation = false,
  isRed = false,
  disabled = false,
  sx = {},
  buttonSx = {},
  isLoading = false,
  loadingIndicator,
}: IHomeBarButton) => {
  const classes = useStyles({
    showPulseAnimation: (showPulseAnimation || isRed) && !disabled,
  });
  const rootClass = { ...classes.root, ...sx };
  const buttonClass = { ...classes.button, ...buttonSx };
  const animationClass = showPulseAnimation
    ? classes.pulseBox
    : isRed
    ? classes.warning
    : {};

  const onClick = (event: MouseEvent<HTMLButtonElement>) => {
    event.currentTarget.blur();
    handleClick(event);
  };

  return (
    <Tooltip title={label}>
      <Box sx={{ ...rootClass, position: 'relative' }}>
        {!disabled ? <Box sx={animationClass} /> : null}
        <IconButton
          disabled={disabled}
          sx={buttonClass}
          onClick={onClick}
          disableRipple
        >
          {icon}
        </IconButton>
        {isLoading && (
          <Box
            sx={{
              position: 'absolute',
              inset: 0,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              pointerEvents: 'none',
              zIndex: 2,
            }}
          >
            {loadingIndicator || (
              <CircularProgress size={32} sx={{ color: COLORS.WHITE }} />
            )}
          </Box>
        )}
      </Box>
    </Tooltip>
  );
};

export default HomeBarButton;
